export const DEFAULT_NETWORK = 'ethereum';
export const NETWORKS = ['ethereum'];

export const NETWORKS_MAP: Record<string, Record<string, string>> = {
  ethereum: {
    name: 'Ethereum Mainnet',
    icon: 'ETH'
  },
  gnosis: {
    name: 'Gnosis Chain',
    icon: 'GNO'
  }
};

export const SYMBOLS_PALETTE: Record<string, string> = {
  DAI: '#F4B731',
  WETH: '#627eea',
  ETH: '#627eea',
  USDC: '#3e73c4',
  WBTC: '#ef8e19',
  BTC: '#ef8e19',
  LINK: '#2a5ada',
  UNI: '#ff007a',
  wstETH: '#00a3ff',
  cbETH: '#0052ff',
  COMP: '#00d395',
  USD: '#00d395',
  cbBTC: '#0052FF',
  rETH: '#FF6E30',
  OP: '#ff0420',
  WMATIC: '#2aadf2',
  GMX: '#2d42fc',
  osETH: '#47347e',
  ARB: '#213147',
  weETH: '#B38DF0',
  stMATIC: '#00a3ff',
  ezETH: '#ace730',
  rsETH: '#075a5a',
  USDT: '#009393',
  MaticX: '#752eea',
  wrsETH: '#075a5a',
  Others: '#FFFFFF',
  others: '#FFFFFF',
  GNO: '#00193C',
  sUSDS: '#00C2A1',
  sDAI: '#8bc34a'
};

export const ACTIVITY_EVENT = [
  {
    value: '',
    label: 'All events'
  },
  {
    value: 'Borrow',
    label: 'Borrow'
  },
  {
    value: 'LiquidationCall',
    label: 'Liquidation Call'
  },
  {
    value: 'Repay',
    label: 'Repay'
  },
  {
    value: 'Supply',
    label: 'Supply'
  },
  {
    value: 'Withdraw',
    label: 'Withdraw'
  },
  {
    value: 'BalanceTransfer',
    label: 'Balance Transfer'
  }
];

export const POOL_ACTIVITY_EVENT = [
  {
    value: '',
    label: 'All events'
  },
  {
    value: 'Borrow',
    label: 'Borrow'
  },
  {
    value: 'LiquidationCall',
    label: 'Liquidation Call'
  },
  {
    value: 'Repay',
    label: 'Repay'
  },
  {
    value: 'Supply',
    label: 'Supply'
  },
  {
    value: 'Withdraw',
    label: 'Withdraw'
  }
];
